import { createGeneralVideoProvider } from '../general';
import { minimaxConfigs } from './configs/minimax';

/**
 * fal.ai 队列（queue.fal.run）视频提供商
 *
 * - 提交：POST /{owner}/{alias}/{endpoint}，创建响应：{ request_id, status_url, response_url, ... }
 * - 轮询：GET /{owner}/{alias}/requests/{request_id}（结果端点，端点子路径不参与）
 *   - 运行中：返回 202 + 队列状态体（无 video 字段 → statePath 取不到值 → 处理中）
 *   - 完成：返回 200 + 模型输出载荷（无状态字段，success 传 [] 按 videoUrlPath 判定成功）
 *   - 失败：返回 4xx/5xx（detail 字段），由 BaseVideoProvider 抛错标记失败
 *
 * 环境变量与图像侧 fal 提供商共用：FAL_BASE_URL=https://queue.fal.run / FAL_API_KEY
 */
export const fal = createGeneralVideoProvider({
    providerName: 'FAL',
    baseUrlEnv: 'FAL_BASE_URL',
    apiKeyEnv: 'FAL_API_KEY',
    debugEnv: 'FAL_DEBUG',
    buildHeaders: (context) => ({
        'Content-Type': 'application/json',
        'Authorization': `Key ${context.apiKey}`,
    }),
    statusMapping: {
        taskIdPath: 'request_id',
        statePath: 'video.url',
        success: [],
        failed: [],
        processing: ['IN_QUEUE', 'IN_PROGRESS'],
        videoUrlPath: 'video.url',
        errorPath: 'detail',
    },
    models: {
        ...minimaxConfigs,
    },
});
